import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/CancelSelfSupplyPurchase`, method: 'PUT', body: null, token: token })
}
